import script from "./AgendaContactos.vue?vue&type=script&setup=true&lang=js"
export * from "./AgendaContactos.vue?vue&type=script&setup=true&lang=js"

import "./AgendaContactos.vue?vue&type=style&index=0&id=36855198&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36855198"]])

export default __exports__